// extracted by mini-css-extract-plugin
module.exports = {"refund-urge-modal":"refund-urge-modal_22_XL4","refundUrgeModal":"refund-urge-modal_22_XL4","content":"content_1fyxUz","highlight":"highlight_2Sp6yW","tips":"tips_1u8bSs"};